// import { AnalyticBlock } from '../components/AnalyticBlock'
import { useEffect, useState } from 'react'
import { getProfilePlan } from '../services/userProfile'
import { TryPremiumModal } from '../modals/TryPremiumModal'
import { useNavigate } from 'react-router-dom'
import { ModalWrapper } from '../modals/ModalWrapper'
import { AnalyticsBlock } from './AnalyticsCustom'
import { useSelector } from 'react-redux'
import { getCurrentUser } from '../store/actions/authActions.ts'
import { RootState, useAppDispatch } from '../store/index.ts'

export const Analytics = () => {
  const [profilePlanInfo, setProfilePlanInfo] = useState<{
    subscribed: boolean
  }>({
    subscribed: false,
  })
  const dispatch = useAppDispatch()
  const {
    user: { data: user },
  } = useSelector((state: RootState) => state.userReducer)

  const [showModal, setShowModal] = useState(false)

  const navigate = useNavigate()

  useEffect(() => {
    // getProfilePlan().then((res) => {
    //   setProfilePlanInfo(res)
    //   setShowModal(!res.subscribed)
    // })

    if (!user?.id) {
      dispatch(getCurrentUser())
    }
  }, [])

  const handleModalClose = () => {
    setShowModal(false)
  }

  return (
    <>
      <div className="sm:ml-[100px]">
        {!profilePlanInfo.subscribed && (
          <ModalWrapper
            showModal={showModal}
            onClose={handleModalClose}
            withHandleKeyDown={false}
          >
            <TryPremiumModal
              showModal={showModal}
              onClose={() => setShowModal(false)}
              onConfirm={() => {
                setShowModal(false)
                navigate('/pricing')
              }}
            />
          </ModalWrapper>
        )}
        <div
          className="overflow-auto"
          style={{
            height: 'calc(100vh - 100px)',
          }}
        >
          <AnalyticsBlock username={user?.username ?? ''} />
        </div>
      </div>
    </>
  )
}